import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import THEME from 'theme';
import { Price } from 'components';
import { Heading } from 'components/chroma';
import { TextSmall } from 'components/chroma/extended';

import { PaymentFrequency } from 'scenes/common/types';
import { SCREEN } from 'scenes/common/types/screen';

const QuoteInformationDesktopContainer = styled.div`
  overflow: auto;
  padding: 1.5em 2em 1em 2em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${THEME.BACKGROUND.CARD};
  margin-top: 1em;

  @media (max-width: ${SCREEN.LARGE_PLUS}px) {
    flex-flow: wrap;
  }
`;

const PriceHeadingSidebarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const PriceDetailsSidebarWrapper = styled.div`
  align-self: flex-end;
  margin-top: 1em;
`;

const Container = styled.div`
  margin-right: 1rem;
  margin-top: 0.5rem;

  @media (max-width: ${SCREEN.LARGE}px) {
    margin-right: 3rem;
  }
`;

type SidebarCardProps = {
  paymentFrequency: PaymentFrequency;
  coverType: string;
  premiumAmount: string;
  instalmentAmount: string;
  firstInstalment: string;
  followingMonths: string;
};

const SidebarCard: FunctionComponent<SidebarCardProps> = ({
  paymentFrequency,
  coverType,
  premiumAmount,
  instalmentAmount,
  firstInstalment,
  followingMonths,
}) => (
  <>
    <QuoteInformationDesktopContainer>
      <PriceHeadingSidebarWrapper>
        <Container>
          {paymentFrequency !== PaymentFrequency.Unspecified ? (
            <Heading size={3} margin={{ bottom: 0 }}>
              Pay {paymentFrequency}
            </Heading>
          ) : (
            <></>
          )}
          <Heading size={3}>{coverType}</Heading>
        </Container>
        <div>
          {paymentFrequency === PaymentFrequency.Monthly ? (
            <div>
              {firstInstalment !== followingMonths ? (
                <>
                  <Price amount={firstInstalment} sidebarDisplay />
                  <TextSmall textAlign="right">(First month)</TextSmall>
                  <Price amount={followingMonths} sidebarDisplay />
                  <TextSmall textAlign="right">(Following months)</TextSmall>
                </>
              ) : (
                <Price amount={instalmentAmount} sidebarDisplay />
              )}
              <PriceDetailsSidebarWrapper>
                <TextSmall
                  weight={400}
                  margin={{ top: 0, bottom: 0 }}
                  textAlign="right"
                >
                  Annual total: ${premiumAmount}
                </TextSmall>
                <TextSmall weight={400} margin={{ top: 0 }} textAlign="right">
                  Inc GST, government charges &amp; any discount
                </TextSmall>
              </PriceDetailsSidebarWrapper>
            </div>
          ) : (
            <div>
              <Price amount={premiumAmount} sidebarDisplay />
              <PriceDetailsSidebarWrapper>
                <TextSmall weight={400} margin={{ top: 0 }} textAlign="right">
                  Inc GST, government charges &amp; any discount
                </TextSmall>
              </PriceDetailsSidebarWrapper>
            </div>
          )}
        </div>
      </PriceHeadingSidebarWrapper>
    </QuoteInformationDesktopContainer>
  </>
);

export default SidebarCard;
